import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "./commonComponents/ApiEndpoints";
import toast from "react-hot-toast";
import { useAuth } from "./AuthContext";

const AssignUserRole = () => {
  const {token} = useAuth()
  const { id } = useParams();
  const location = useLocation();
  const { userData } = location.state || {};
  const [roles, setRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
// const [email, setEmail] = useState(userData?.email || "");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"

  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const allAvailableRoles = [
    { value: "admin", label: "Administrator", icon: "👑", color: "danger" },
    { value: "accountant", label: "Accountant", icon: "👨‍🏫", color: "primary" },
    // { value: "student", label: "Student", icon: "🎓", color: "success" },
    { value: "marketer", label: "Marketer", icon: "📈", color: "warning" },
    // { value: "parents", label: "Parent", icon: "👨‍👩‍👧", color: "info" }
  ];

  // 🔹 Fetch current user roles
 useEffect(() => {
    const fetchRoles = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          BASE_URL + `/get/user/role/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ pass token here
            },
          }
        );
        if (res.data.status) {
          setSelectedRoles(res.data.roles.map(r => r.role));
        }
      } catch (err) {
        showMessage("Failed to load user roles.", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchRoles();
  }, [id]);


  // Checkbox toggle
  const handleCheckboxChange = (role) => {
    setSelectedRoles(prev =>
      prev.includes(role) ? prev.filter(r => r !== role) : [...prev, role]
    );
  };

  // Show message helper
  const showMessage = (msg, type = "info") => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => {
      setMessage("");
      setMessageType("");
    }, 5000);
  };

  // Submit roles
  const handleSubmit = async () => {
    if (!userData?.email) {
      showMessage("User email is missing.", "error");
      return;
    }

    const instituteId = Cookies.get("institute_id") || 5;
    const payload = {
      user_id: Number(id),
      email: userData.email,
      role: selectedRoles,
      institute_id: Number(instituteId),
    };

    try {
      setLoading(true);
      const res = await axios.post(`${BASE_URL}/user/set/role/`, payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.status) {
        showMessage("✅ Roles updated successfully!", "success");
      } else {
        showMessage(res.data.message || "Failed to update roles.", "error");
      }
    } catch (error) {
      const resData = error.response?.data;
      if (resData?.message) showMessage(resData.message, "error");
      if (resData?.errors) {
        Object.values(resData.errors).forEach(errArr =>
          errArr.forEach(msg => showMessage(msg, "error"))
        );
      }
      if (!resData) showMessage("Something went wrong. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Badge color
  const getRoleColor = (roleValue) => {
    const role = allAvailableRoles.find(r => r.value === roleValue);
    return role ? role.color : "secondary";
  };


  return (

     <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0 ">Assign User Roles</h2>
        </div>
        </div>
    <div className="container py-4">
      <div className="row justify-content-start d-flex">
        {/* <div className="col-12 col-md-8 col-lg-6"> */}
          {/* Header */}
          <div className="text-center mb-4">
            <p className="text-muted">Assign and manage roles for system users</p>
          </div>

          {/* Main Card */}
          {/* <div className="card shadow-lg border-0 rounded-3"> */}
           {/* <div className="card-body p-4"> */}
              {/* Loading Spinner */}
              {loading && (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-muted mt-2">Loading user data...</p>
                </div>
              )}

              {!loading && (
                <>
                  {/* User Information */}
                <div className="row mb-4 text-start">
                  <div className="col-12 col-sm-6 mb-3">
                    <label className="form-label fw-semibold text-dark d-block">
                       <i className="bi bi-person-badge me-2"></i>
                      User Name
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-light">
                        <i className="bi bi-hash text-muted"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        value={userData ? userData.name : 'Loading...'  }
                        disabled
                      />
                    </div>
                  </div>

                    <div className="col-12 col-sm-6 mb-3">
                      <label className="form-label fw-semibold text-dark">
                         <i className="bi bi-envelope me-2"></i>
                        Email Address
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-light">
                          <i className="bi bi-at text-muted"></i>
                        </span>
                        <input
                          type="email"
                          className="form-control"
                          value={userData?.email}
                          // onChange={(e) => setEmail(e.target.value)}
                          placeholder="Enter user email"
                        />

                      </div>
                    </div>
                  </div>

                  {/* Current Roles Summary */}
                  {selectedRoles.length > 0 && (
                    <div className="mb-4 text-start">
                      <label className="form-label fw-semibold text-dark mb-3">
                        <i className="bi bi-check-circle me-2"></i>
                        Current Roles
                      </label>
                      <div className="d-flex flex-wrap gap-2">
                        {selectedRoles.map((role) => (
                          <span 
                            key={role} 
                            className={`badge bg-${getRoleColor(role)} bg-gradient px-3 py-2 rounded-pill`}
                          >
                            <i className="bi bi-check-lg me-1"></i>
                            {allAvailableRoles.find(r => r.value === role)?.label || role}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Role Selection */}
                  <div className="mb-4 text-start">
                    <label className="form-label fw-semibold text-dark mb-3">
                      <i className="bi bi-list-check me-2"></i>
                      Available Roles
                    </label>
                    <div className="row g-3">
                      {/* {allAvailableRoles.map((role) => (
                        <div key={role.value} className="col-12 col-sm-6">
                          <div className={`card h-100 border-2 ${selectedRoles.includes(role.value) ? `border-${role.color} shadow-sm` : 'border-light'}`}>
                            <div className="card-body p-3">
                              <div className="form-check d-flex align-items-center mb-0">
                                <input
                                  className="form-check-input me-3"
                                  type="checkbox"
                                  id={role.value}
                                  checked={selectedRoles.includes(role.value)}
                                  onChange={() => handleCheckboxChange(role.value)}
                                  style={{ transform: "scale(1.2)" }}
                                />
                                <label 
                                  className="form-check-label d-flex align-items-center w-100" 
                                  htmlFor={role.value}
                                >
                                  <span className="fs-4 me-3">{role.icon}</span>
                                  <div>
                                    <div className="fw-semibold text-dark">{role.label}</div>
                                    <small className="text-muted text-capitalize">{role.value}</small>
                                  </div>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))} */}
                       {allAvailableRoles.map(role => (
                <div key={role.value} className="col-12 col-sm-6">
                  <div className={`card border-2 ${selectedRoles.includes(role.value) ? `border-${role.color}` : 'border-light'}`}>
                    <div className="card-body p-2">
                      <div className="form-check d-flex align-items-center mb-0">
                        <input
                          type="checkbox"
                          className="form-check-input me-2"
                          id={role.value}
                          checked={selectedRoles.includes(role.value)}
                          onChange={() => handleCheckboxChange(role.value)}
                        />
                        <label className="form-check-label d-flex align-items-center" htmlFor={role.value}>
                          <span className="fs-4 me-2">{role.icon}</span>
                          <div>
                            <div className="fw-semibold">{role.label}</div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
                    </div>
                  </div>

                  {/* Message Alert */}
                  {message && (
                    <div className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'error' ? 'danger' : 'info'} alert-dismissible fade show d-flex align-items-center`} role="alert">
                      <i className={`bi ${messageType === 'success' ? 'bi-check-circle-fill' : messageType === 'error' ? 'bi-exclamation-triangle-fill' : 'bi-info-circle-fill'} me-2`}></i>
                      <div className="flex-grow-1">{message}</div>
                      <button 
                        type="button" 
                        className="btn-close" 
                        onClick={() => setMessage("")}
                      ></button>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className="d-flex gap-2 justify-content-end pt-3 border-top">
                    <button 
                      className="btn btn-outline-secondary px-4 rounded-pill"
                      onClick={() => window.history.back()}
                    >
                      <i className="bi bi-arrow-left me-2"></i>
                      Back
                    </button>
                    <button
                      className="btn btn-primary px-4 rounded-pill d-flex align-items-center"
                      onClick={handleSubmit}
                      disabled={loading || !userData?.email}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Saving...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-check-lg me-2"></i>
                          Save Changes
                        </>
                      )}
                    </button>
                  </div>
                </>
              )}
            {/* </div> */}
          {/* </div> */}

          {/* Help Text */}
          <div className="text-center mt-4">
            <small className="text-muted">
              <i className="bi bi-info-circle me-1"></i>
              Select one or multiple roles to assign to <span className="text-dark fw-semibold">{userData?.name}</span>. Changes take effect immediately.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignUserRole;